import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import { rrfProps, store } from './redux/store';

import { ReactReduxFirebaseProvider } from 'react-redux-firebase';

// ReactDOM.render(
//     <Provider store={store}>
//       <ReactReduxFirebaseProvider {...rrfProps}>
//         <AuthIsLoaded>
//           <App />
//         </AuthIsLoaded>
//       </ReactReduxFirebaseProvider>
//     </Provider>,
//   document.getElementById('root')
// );


ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <App />
    </ReactReduxFirebaseProvider>
  </Provider>,
document.getElementById('root')
);